// Formatting utilities for the grid.
// The DevExpress DataTypeProvider wrappers have been removed; formatting
// is now applied directly in TanStack column definitions (see grid/index.js).
// These helpers are still exported for use by other components.

export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === undefined || bytes === null) return '-'
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}
